// extracted by mini-css-extract-plugin
export default {"ops":"NodeOps_ops__g2AuN","desktopOps":"NodeOps_desktopOps__nQVF7","opBtn":"NodeOps_opBtn__L4h10","danger":"NodeOps_danger__SylTJ","moreBtn":"NodeOps_moreBtn__XOtmt"};